import React from 'react';
import Header from '../common/Header';
import AddressDetails from '../user/AddressDetails';
import { useNavigate } from 'react-router-dom';
import httpService from "../../services/HttpService";

const OrderAddressAdd = () => {
    const navigate = useNavigate();
    const pendingOrderId = localStorage.getItem('pending_order_id'); // Get the pending order ID

    const handleAddressSubmit = async (updatedAddress) => {
        try {
            // Step 1: Create a new address using httpService
            const response = await httpService.post('/address', updatedAddress); // Use httpService.post
            const createdAddress = await response.json(); // Parse the response as JSON

            // Step 2: Update the order with the created address ID
            if (pendingOrderId) {
                const orderResponse = await httpService.put(`/orders/${pendingOrderId}`, {
                    address_id: createdAddress.id,
                }); // Use httpService.put
                await orderResponse.json(); // Parse the response as JSON
            }
            // Navigate to the next step after success
            
            const cityId = createdAddress.city_id
            localStorage.setItem('pending_order', JSON.stringify({cityId}));
            navigate('/order-time');
        } catch (err) {
            console.error(err.message);
        }
    };

    return (
        <>
            <Header />
            <div className="address-single-page">
                <AddressDetails
                    initialData={null} // No initial data for a new address
                    onSubmit={handleAddressSubmit} // Submit handler
                    buttonText="ДОБАВИТЬ АДРЕС И ПРОДОЛЖИТЬ"
                />
            </div>
        </>
    );
};

export default OrderAddressAdd;